import React, { useState, useEffect } from "react";
// import { FormGroup, FormControl, ControlLabel } from "react-bootstrap";
import { Grid, Typography, Paper, Box } from "@mui/material";
//import LoaderButton from "../components/common/LoaderButton";
import { useDispatch } from "react-redux";
import { clearStore } from "../store/actions/index";
import Swal from "sweetalert2";
import ReactGA from "react-ga";
import "../components/LandingPage.css";
import { makeStyles } from "tss-react/mui";
import { persistor } from "../store";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import {
  getAgencyInfoForBDSAdminAccount,
  setAgencySessionVariables,
  setDirectorsIDSessionVariables,
  login,
  isUserAuthenticated,
  isRecruiter,
  getUserInfo,
} from "../services/GraphQl/BDSWebService";
import { useHistory } from "react-router-dom";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: "center",
  color: theme.palette.text.secondary,
  height: 60,
  lineHeight: "60px",
}));
const darkTheme = createTheme({ palette: { mode: "dark" } });
const lightTheme = createTheme({ palette: { mode: "light" } });

const useStyles = makeStyles()((theme) => {
  return {
    root: {
      textAlign: "center",
      height: "100vh",
      background:
        "linear-gradient(to bottom right, #4c5255, #000000) !important",
      backgroundColor: "rgb(68, 66, 66)",
    },
    BannerStart: {
      color: "#FFFFFF",
      fontSize: "calc(48px + (36 - 24) * ((100vw - 250px) / (4000 - 250)))",
      lineHeight: "calc(1.3em + (1.5 - 1.2) * ((100vw - 250px)/(3000 - 250)))",
      fontFamily: "mazBold",
      [theme.breakpoints.down("sm")]: {
        fontSize: "calc(24px + (36 - 24) * ((50vw - 250px) / (4000 - 250)))",
        lineHeight: "calc(1.3em + (1.5 - 1.2) * ((50vw - 250px)/(3000 - 250)))",
      },
    },
    BannerEnd: {
      color: "#FFFFFF",
      fontSize: "calc(48px + (36 - 24) * ((100vw - 250px) / (4000 - 250)))",
      lineHeight: "calc(1.3em + (1.5 - 1.2) * ((100vw - 250px)/(3000 - 250)))",
      fontFamily: "maz",
      [theme.breakpoints.down("sm")]: {
        fontSize: "calc(24px + (36 - 24) * ((50vw - 250px) / (4000 - 250)))",
        lineHeight: "calc(1.3em + (1.5 - 1.2) * ((50vw - 250px)/(3000 - 250)))",
      },
    },
  };
});

const LoginWithLanding = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    ReactGA.pageview(
      "/login",
      [],
      "Agency - " + sessionStorage.getItem("agencyId") + " viewed login page."
    );
  }, []);

  const handleRegister = async () => {
    const {
      history: { push },
    } = props;
    push("/register");
  };

  const validateForm = () => {
    return email.length > 0 && password.length > 0;
  };

  const handleChange = (event) => {
    event.preventDefault();

    if (event.target.id === "email") {
      setEmail(event.target.value);
    } else if (event.target.id === "password") {
      setPassword(event.target.value);
    }
  };

  async function showAgencyPrompt(recruiter) {
    const result = await Swal.fire({
      title: "Enter Agency ID",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#1976d2",
      input: "text",
      inputPlaceholder: "Agency ID",
      inputAttributes: {
        id: "swal-input1",
        "aria-label": "Agency ID",
      },
      html: recruiter
        ? `<label style="display:align-items:center;margin-top:8px;">
            <input type="checkbox" id="swal-checkbox"> Show All
         </label>`
        : undefined,
      focusConfirm: false,
      confirmButtonText: "Submit",
      didOpen: () => {
        if (recruiter) {
          const checkbox = document.getElementById("swal-checkbox");
          const input = document.getElementById("swal-input1");
          const titleEl = document.querySelector(".swal2-title");
          if (checkbox && input && titleEl) {
            checkbox.addEventListener("change", () => {
              input.value = ""; // Clear input when checkbox is checked
              input.hidden = checkbox.checked;
              // Update the SweetAlert title text based on checkbox state
              titleEl.textContent = checkbox.checked
                ? "Show All Agencies"
                : "Enter Agency ID";
              input.setAttribute("title", titleEl.textContent);
            });
          }
        }
      },
      preConfirm: () => {
        return {
          submission: true,
          agencyId: document.getElementById("swal-input1").value || "",
          showAll: recruiter
            ? document.getElementById("swal-checkbox").checked
            : false,
        };
      },
    });

    if (result.isConfirmed) {
      return result.value;
    } else {
      return { agencyId: "", submission: false, showAll: false };
    }
  }

  const ProcessAgencyIds = async (directorId) => {
    setDirectorsIDSessionVariables(directorId);
    setAgencySessionVariables([]);
  };

  const ProcessAgencyId = async (formValues) => {
    let selectedAgencyId = formValues.agencyId;

    await getAgencyInfoForBDSAdminAccount(selectedAgencyId)
      .then(async (res) => {
        if (res) {
          selectedAgencyId = res[0].agencyId;
          setAgencySessionVariables(res[0]);
          setDirectorsIDSessionVariables([]);
        } else {
          Swal.fire(
            "Please enter current agency id and try again.",
            "",
            "error"
          );
        }
      })
      .catch((e) => {
        throw new Error("cant validate agency id with error " + e.message);
      });
  };

  const catchIssue = (e) => {
    let errorMsg = e.message;
    if (errorMsg.search("Incorrect username or password.") !== -1) {
      errorMsg = "Incorrect password.";
    }
    if (errorMsg.search("No such user") !== -1) {
      errorMsg = "Incorrect username.";
    }
    Swal.fire("Oops!", errorMsg, "error");
  };

  const isFormValuesValid = (formValues) => {
    if (formValues.submission) {
      if (formValues.submission === false) {
        return false;
      }
      if (formValues.showAll) {
        return true;
      }
      if (!formValues.agencyId || formValues.agencyId === "") {
        Swal.fire("Please enter correct agency id.", "", "error");
        return false;
      }
    } else {
      return false;
    }
    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    let selectedAgencyId = "";
    try {
      sessionStorage.clear();
      await login(email, password)
        .then(async (loginResult) => {
          /* for admin users we need to display a agency_id selector */
          sessionStorage.setItem(
            "isStaging",
            window.location.href.includes("://theagencydashboard.com") ||
              window.location.href.includes("://www.theagencydashboard.com")
              ? false
              : true
          );

          if (loginResult.__typename === "AdminLogin") {
            const directorId = loginResult.userInfo.id; //production testing
            //const directorId = 2856819; // Hardcoded for testing purposes for Director
            //const directorId = 30126; // Hardcoded for testing purposes for non Director

            const recruiter = await isRecruiter(parseInt(directorId));

            sessionStorage.setItem("directorId", directorId);

            const userInfo = await getUserInfo(directorId.toString(), "admin");

            sessionStorage.setItem("displayName", userInfo.displayName);

            const formValues = await showAgencyPrompt(recruiter);

            if (!isFormValuesValid(formValues)) {
              return;
            }

            if (formValues.showAll) {
              await ProcessAgencyIds(directorId);
            } else {
              await ProcessAgencyId(formValues);
            }
          } else {
            const directorId = loginResult.agencyInfo.agencyId;
            selectedAgencyId = directorId;
            setAgencySessionVariables(loginResult.agencyInfo);
            sessionStorage.setItem(
              "displayName",
              loginResult.agencyInfo.agencyName
            );
            sessionStorage.setItem("directorId", directorId);
          }
        })
        .catch((e) => {
          catchIssue(e);
        });
    } finally {
      finishLogin(selectedAgencyId);
      setIsLoading(false);
    }
  };

  const finishLogin = async (agencyId) => {
    if (await isUserAuthenticated()) {
      /* clear existing state */
      persistor.purge();
      dispatch(clearStore());
      ReactGA.event({
        category: "UserLoginIn",
        action: "Login",
        label: "Agency : " + agencyId + " logged in.",
      });
      const {
        history: { push },
      } = props;
      push("/main");
    }
  };

  const { classes } = useStyles();

  return (
    <Grid
      className={classes.root}
      container
      spacing={0}
      direction="row"
      alignContent="center"
      justifyContent="center"
      alignItems="center"
    >
      <Grid item xs={12} sm={5}>
        <Grid
          container
          justifyContent="center"
          direction="column"
          alignItems="center"
        >
          <Grid
            container
            justifyContent="center"
            data-tour="ad__dashboardTitle"
            direction="row"
            wrap="nowrap"
          >
            <Typography
              className={classes.BannerStart}
              sx={{ fontWeight: "bolder" }}
            >
              AGENCY
            </Typography>
            <Typography
              className={classes.BannerEnd}
              sx={{ fontWeight: "lighter" }}
            >
              DASHBOARD
            </Typography>
          </Grid>
          <Grid
            item
            style={{
              margin: "10%",
              width: "80%",
              padding: 10,
              textAlign: "center",
            }}
          >
            <form>
              <Box sx={{ flexGrow: 0 }}>
                <Grid container>
                  {[darkTheme].map((theme, index) => (
                    <Grid key={index} size={12}>
                      <ThemeProvider theme={theme}>
                        <Box
                          sx={{
                            p: 2,
                            borderRadius: 2,
                            bgcolor: "background.paper",
                            display: "grid",
                            elevation: 4,
                            boxShadow: 3,
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <Grid>
                            <Typography
                              component="span"
                              variant="h4"
                              color="inherit"
                              sx={{
                                fontSize: "1.5em",
                                fontWeight: 400,
                                color: "red",
                              }}
                            >
                              Notice: Upcoming System Transition
                            </Typography>
                          </Grid>
                          <Grid sx={{ marginTop: 2 }}>
                            <Typography variant="h6" color="textPrimary">
                              As part of our ongoing commitment to aid in the
                              success of your business, please login to your
                              IntegrityConnect here:
                            </Typography>
                          </Grid>
                          <Grid sx={{ marginTop: 2 }}>
                            <Typography variant="h6" color="textPrimary">
                              The Agency Dashboard has been retired as a result of a database upgrade. As part of our ongoing commitment to aid in the success of your business, we will soon offer a system replacement, IntegrityConnect Plus, coming in January. IntegrityCONNECT Plus is designed to deliver similar reporting that you have been relying on to continue to effectively manage and grow your business. During this transition, we will ensure that your data and services remain secure and uninterrupted.
                            </Typography>
                          </Grid>
                          <Grid sx={{ marginTop: 2 }}>
                            <Typography variant="h6" color="textPrimary">
                              We appreciate your patience and support as we make this transition. More details and guidance will be shared in the coming weeks.
                            </Typography>
                          </Grid>
                          <Grid sx={{ marginTop: 2 }}>
                            <Typography variant="h6" color="textPrimary">
                              Thank you for being a valued agency partner.
                            </Typography>
                          </Grid>
                        </Box>
                      </ThemeProvider>
                    </Grid>
                  ))}
                </Grid>
              </Box>
              {/* <form onSubmit={handleSubmit}> */}
              {/* <FormGroup controlId="email" bsSize="large">
                <ControlLabel style={{ color: "#eee" }}>Username</ControlLabel>
                <FormControl value={email} onChange={(e) => handleChange(e)} />
              </FormGroup>
              <FormGroup controlId="password" bsSize="large">
                <ControlLabel style={{ color: "#eee" }}>Password</ControlLabel>
                <FormControl
                  value={password}
                  onChange={(e) => handleChange(e)}
                  type="password"
                />
              </FormGroup>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                }}
              >
                <LoaderButton
                  style={{
                    backgroundColor: "#00aeef",
                    color: "#eee",
                    width: "100%",
                    fontWeight: "bolder",
                    fontSize: "1.65rem",
                  }}
                  bssize="small"
                  disabled={!validateForm()}
                  type="submit"
                  isLoading={isLoading}
                  text="Login"
                  loadingText="Logging in…"
                />
              </div>
              <Button
                onClick={handleRegister}
                variant="text"
                sx={{ color: "#fff", mt: 1.5, fontSize: 9 }}
              >
                register
              </Button>

              <Button
                onClick={() => {
                  history.push("/resetpassword");
                }}
                variant="text"
                sx={{ color: "#fff", mt: 1.5, fontSize: 9 }}
              >
                forgot password
              </Button>

              <br />
              <br />
              <br />
              <Typography
                variant="h6"
                style={{ color: "white" }}
                textAlign={"center"}
                dangerouslySetInnerHTML={{
                  __html: `
                    Please contact Agent Support at <a href="tel:+18887452320">888-745-2320</a>  
                    or <a href="mailto:agentsupport@berwickinsurance.com">agentsupport@berwickinsurance.com</a> 
                    to assist with registration, password reset, or technical issues.
                  `,
                }}
              /> */}
            </form>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-end"
            direction="column"
          >
            <Grid item xs={12} style={{ padding: 10 }}></Grid>
          </Grid>
          <Grid container alignItems="center" direction="row">
            <Grid
              item
              xs={12}
              style={{
                paddingBottom: 10,
              }}
            >
              <span className="poweredBy" style={{ color: "#eee" }}>
                Powered By: &nbsp;&nbsp;{" "}
                <a
                  data-tour="ad__berwickLogo"
                  target={"_blank"}
                  href="https://berwickinsurance.com"
                  rel="noreferrer"
                >
                  <img
                    style={{
                      height: 80,
                      display: "block",
                      margin: "auto",
                      padding: 5,
                      filter: "brightness(1.75)",
                    }}
                    src="Berwick_Color_Tag@2x.png"
                    alt="berwick logo"
                  />
                </a>
              </span>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default LoginWithLanding;
